import cn from 'classnames';

import { CampaignStatus, CampaignStatuses } from '@features/campaigns/shared/types/campaign';
import { DataStatuses } from '@shared/types/common.ts';
import { BillingInfoDataStatus } from '@shared/types/userProfile.types.ts';

import styles from './StatusIcon.module.scss';

type PossibleStatuses = CampaignStatus | BillingInfoDataStatus;
const CombinedUniqueStatuses = { ...CampaignStatuses, ...DataStatuses };

const statusIconStyles: Record<PossibleStatuses, string> = {
  [CombinedUniqueStatuses.DRAFT]: styles.draft,
  [CombinedUniqueStatuses.BUDGET_APPROVAL]: styles.budgetApproval,
  [CombinedUniqueStatuses.FAILED]: styles.failed,
  [CombinedUniqueStatuses.IN_APPROVAL]: styles.inApproval,
  [CombinedUniqueStatuses.APPROVED]: styles.approved,
  [CombinedUniqueStatuses.DELIVERING]: styles.delivering,
  [CombinedUniqueStatuses.COMPLETED]: styles.completed,
  [CombinedUniqueStatuses.PAUSED]: styles.paused,
  [CombinedUniqueStatuses.PENDING]: styles.pending,
  [CombinedUniqueStatuses.REJECTED]: styles.rejected,
};

export type PossibleStatusDataVariant = CampaignStatus | BillingInfoDataStatus;

interface StatusIconProps {
  variant: PossibleStatusDataVariant;
}

export default function StatusIcon({ variant }: StatusIconProps) {
  return <span className={cn(styles.commonStatusIcon, statusIconStyles[variant])} />;
}
